var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrashRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-trash-red",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 202.098,
    viewBox: "0 0 150 202.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 150,
    height: 202.098,
    fill: "#ff5c5c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M150,37.272a16.646,16.646,0,0,0-16.627-16.628H105.066A21.37,21.37,0,0,0,83.735,0H66.264A21.37,21.37,0,0,0,44.933,20.644H16.627a16.625,16.625,0,0,0-6.021,32.122V167.5A34.633,34.633,0,0,0,45.2,202.1h59.6A34.633,34.633,0,0,0,139.393,167.5V52.766A16.651,16.651,0,0,0,150,37.272M66.264,10.4H83.735A10.953,10.953,0,0,1,94.648,20.644h-39.3A10.954,10.954,0,0,1,66.264,10.4m62.729,157.1A24.222,24.222,0,0,1,104.8,191.7H45.2A24.221,24.221,0,0,1,21.006,167.5V54.256H128.993ZM133.372,43.5H16.627a6.227,6.227,0,0,1,0-12.455H133.372a6.227,6.227,0,0,1,0,12.455",
    fill: "#ff5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M61.42,203.809a5.2,5.2,0,0,0,5.2-5.2V96.071a5.2,5.2,0,1,0-10.4,0V198.609a5.2,5.2,0,0,0,5.2,5.2",
    transform: "translate(-17.24 -27.866)",
    fill: "#ff5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M107.746,203.809a5.2,5.2,0,0,0,5.2-5.2V96.071a5.2,5.2,0,1,0-10.4,0V198.609a5.2,5.2,0,0,0,5.2,5.2",
    transform: "translate(-31.446 -27.866)",
    fill: "#ff5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M153.181,203.809a5.2,5.2,0,0,0,5.2-5.2V96.071a5.2,5.2,0,1,0-10.4,0V198.609a5.2,5.2,0,0,0,5.2,5.2",
    transform: "translate(-45.379 -27.866)",
    fill: "#ff5c5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashRed);
export default __webpack_public_path__ + "static/media/icon-trash-red.d8869924f9701774486d0209e4f970c9.svg";
export { ForwardRef as ReactComponent };